import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-modal-subheader',
  templateUrl: './modal-subheader.component.html',
  styleUrls: ['./modal-subheader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSubheaderComponent {}
